import {
    Component,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import Utils from '@app/utils/utils';

@Component({
    selector: 'ag-icon-wrapper',
    template: `
        <ag-icon
            [name]="iconName"
            [url]="iconSvgFileUrl">
        </ag-icon>
    `,
    styles: [
        ` :host {
            display: inline-flex;
            font-size: inherit;
        }
        `
    ]
})
export class AgIconWrapperComponent implements OnChanges {
    // Must be the name of the icon svg file i.e. iconName.svg in /assets/icons.
    @Input() public iconName: string;
    private iconSvgFileUrl = null;

    setUpIcon(iconName) {
        if (!this.iconName) {
            throw new Error('Must specify valid iconName value');
        }
        // For icons that are not from the AWF library, get it's svg file url
        if (!iconName.startsWith('awf-')) {
            this.iconSvgFileUrl = Utils.getIconFileUrl(iconName);
            this.iconName = null; // Must be null if url is used
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.setUpIcon(changes.iconName.currentValue);
    }

}
